import { useI18n } from "@/context/I18nContext";
import { fmtPrice } from "@/lib/format";

function statusColor(ok) {
  return ok ? "var(--mq-green)" : "var(--mq-red)";
}

export default function ExchangesGrid({ state }) {
  const { t } = useI18n();
  const exchanges = state?.exchanges || {};
  const entries = Object.entries(exchanges);

  if (entries.length === 0) {
    return null;
  }

  return (
    <div className="mq-panel" data-testid="exchanges-grid">
      <div className="mq-panel-header">
        <span className="mq-heading text-sm font-semibold tracking-wider">
          EXCHANGES · {entries.length} active
        </span>
        <span className="mq-label">
          {state?.live_trading_enabled ? (
            <span style={{ color: "var(--mq-red)" }}>● LIVE TRADING</span>
          ) : (
            <span style={{ color: "var(--mq-yellow)" }}>○ DRY-RUN</span>
          )}
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 divide-x" style={{ borderColor: "var(--mq-border)" }}>
        {entries.map(([name, s]) => {
          const ob = s.order_book || {};
          const h = s.exchange_health || {};
          const r = s.regime || {};
          const c = s.compliance || {};
          return (
            <div key={name} className="p-3" data-testid={`exchange-card-${name}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="mq-heading text-xs font-bold uppercase tracking-wider">
                  {name}
                </span>
                <span
                  className="mq-status-dot"
                  style={{ background: statusColor(h.ok), boxShadow: h.ok ? "0 0 6px var(--mq-green)" : "none" }}
                />
              </div>
              <div className="mq-label">{s.symbol}</div>
              <div className="mq-metric text-lg mt-1">
                {fmtPrice(ob.mid || 0, { withDollar: true })}
              </div>
              <div className="flex justify-between items-center mt-2">
                <span className="text-[10px] text-[var(--mq-text-3)] uppercase">Δ</span>
                <span
                  className="text-xs font-mono"
                  style={{ color: c.spread_ok ? "var(--mq-green)" : "var(--mq-red)" }}
                >
                  {Number(ob.spread_pct || 0).toFixed(3)}%
                </span>
              </div>
              <div className="text-[10px] mt-1" style={{ color: "var(--mq-cyan)" }}>
                [{r.regime || "—"}]
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
